import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import KundenbewertungContactApp from "../components/contact/EventsBewertungApp.vue";

export default function() {
  const element = document.querySelector("#vue-eventbewertung");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      new Vue({
        el: element,

        components: {
          KundenbewertungContactApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(KundenbewertungContactApp)
      })
    });
  }
}
